import $ from 'jquery';
import tdaConfig from 'lib/util/tda.config';
import paramByName from 'lib/getParameterByName';
import zip from 'lib/util/zip';
import zipTools from 'components/zip-tools';
import rtiDealerCode from './rtiDealerCode';

// ! test and localhost to __int for preprod testing
var __int = ['national-preview', 'staging', 'national-staging'];
var __stage = ['localhost', 'test'];
var __dev = ['national-dev'];

function __getEnviron() {
  var parts = window.location.hostname.split('.');
  var subdomain = parts.shift();

  if (__int.includes(subdomain)) {
    return 'int';
  }
  if (__stage.includes(subdomain)) {
    return 'stage';
  }
  if (__dev.includes(subdomain)) {
    return 'dev';
  }
  return 'prod';
}

function __rticCDN() {
  // return vals match that found in fixed-layout in LSDS
  var env = __getEnviron();
  if (env === 'int') return 'https://cdn.rticint.deops.toyota.com';
  if (env === 'stage') return 'https://cdn.rticstage.deops.toyota.com';
  if (env === 'dev') return 'https://cdn.rticdev.deops.toyota.com';
  return 'https://cdn.rtic.toyota.com';
}

function __getAzureClientId() {
  var parts = window.location.hostname.split('.');
  var subdomain = parts.shift();
  var idPreproduction = '061a2c23-9429-4172-abaf-81e1b9ee15a0';
  var idProduction = '183ec5eb-abf3-4430-9451-9fad08ce61d4';
  var preprod = ['dev', 'test'];
  if (preprod.includes(subdomain)) {
    return idPreproduction;
  }
  return idProduction;
}

var reusableComp = {
  searchInit: function () {
    window.viewConfig = {
      dealerCd: paramByName('dealerCd'),
      series: paramByName('series'),
      detailsRoute: `${tdaConfig.site.context_url}/inventory/details/:vin`,
      // detailsRoute: `${tdaConfig.site.context_url}/inventory/details/`,
      zipcode: zip.getCookiedDefaultFallback(),
      env: __getEnviron(),
      backToVehiclesPath: `/${tdaConfig.site.context_url}/inventory/`,
      selectedModels: paramByName('selectedModels') ? paramByName('selectedModels') : '', // 'camry le, etc'
      extColor: paramByName('extColor') ? paramByName('extColor') : '',
      packagesAccessories: paramByName('packagesAccessories') ? paramByName('packagesAccessories') : '',
      engineAndTransmission: paramByName('engineAndTransmission') ? paramByName('engineAndTransmission') : '',
      priceMin: paramByName('priceMin') ? paramByName('priceMin') : '',
      priceMax: paramByName('priceMax') ? paramByName('priceMax') : '',
      zipModalHook: this.searchModalHook,
      campaignCodes: {
        dealerDesktop: 'TXBT36350000',
        dealerMobile: 'TXBT36350001',
        priceDesktop: 'TXBT36360000',
        priceMobile: 'TXBT36360001',
        offerDesktop: 'TXBT36370000',
        offerMobile: 'TXBT36370001'
      },
      azureClientId: __getAzureClientId,
      relativeRedirectUrl: '/en/inventory/gxp-sso/' // BOTH en and es use this! (and it works!?)
    };
    this.searchLoad();
  },

  searchLoad: function () {
    $.ajax({
      url: `${__rticCDN()}/static/rti/latest/deploy/smartpath-spa/bundle.js`,
      // url: `${__rticCDN()}/static/rti/latest/deploy/search/bundle.js`,
      dataType: 'script',
      cache: true
    }).done(function () {
    }).fail(function (data) {
      console.log('error: ', data);
    });
  },

  // Does this bologna work?
  searchModalHook: function () {
    zipTools.showPromptUserZipModal(
      zip.getCookiedDefaultFallback(),
      zip.getCookiedDefaultFallback(),
      undefined,
      '',
      true,
      true
    );
  },

  detailsInit: function () {
    var dealer_code = rtiDealerCode.savedDealerCode();
    var vinProp = paramByName('vin');
    var zipProp = zip.getCookiedDefaultFallback(); // '80634'
    var seriesProp = paramByName('series'); // 'camry'
    var vlpPath = `/${tdaConfig.site.context_url}/inventory/search/?series=${seriesProp}&zipcode=${zipProp}&dealerCd=${dealer_code}`;
    var specialsHref = `/${tdaConfig.site.context_url}/offers/${seriesProp}/index.page`; // absolute link to similar offers

    window.viewConfig = {
      dealerId: dealer_code,
      vin: vinProp,
      zip: zipProp,
      promoteDesc: true,
      env: __getEnviron(),
      backToVlpPath: vlpPath,
      campaignCodes: {
        dealerDesktop: 'TXBT36350000',
        dealerMobile: 'TXBT36350001',
        priceDesktop: 'TXBT36360000',
        priceMobile: 'TXBT36360001',
        offerDesktop: 'TXBT36370000',
        offerMobile: 'TXBT36370001'
      },
      azureClientId: __getAzureClientId(),
      relativeRedirectUrl: '/en/inventory/gxp-sso/', // BOTH en and es use this!
      localSpecialsHref: specialsHref
    };

    this.detailsLoad();
  },

  detailsLoad: function () {
    $.ajax({
      url: `${__rticCDN()}/static/rti/latest/deploy/smartpath-spa/bundle.js`,
      // url: `${__rticCDN()}/static/rti/latest/deploy/details/bundle.js`,
      dataType: 'script',
      cache: true
    }).done(function () {

    }).fail(function (data) {
      console.log('error: ', data);
    });
  },

  ssoInit: function () {
    // reusable component viewConfig object, required on page before bundle.js
    window.viewConfig = {
      azureClientId: __getAzureClientId(),
      env: __getEnviron()
    };

    // this 404s in prod too.
    $.ajax({
      url: `${__rticCDN()}/static/rti/latest/deploy/sso-redirect/bundle.js`,
      dataType: 'script',
      cache: true
    }).done(function () {
      console.log('loaded SSO: ', window.viewConfig);
    }).fail(function (data) {
      console.log('SSO error: ', data);
    });
  }
};

export default reusableComp;
